module.exports = __webpack_public_path__ + "static/favicon-ad21948c81726a83d1c5e84ed21edeed.ico";